"use client";

import { HighlightGrid, HighlightItem, HighlightPanel } from "daskapital-ds";

import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import getBlockStyles from "@/lib/wordpress/blocks/getBlockStyles";
import { mediaIconElement } from "@/lib/wordpress/blocks/mediaIconElement";
import { useMemo } from "react";

export type IBlockHighlightGrid = {
  attrs: {
    anchor?: string;
    variant?: string;
    itemTextOverride?: boolean;
    itemTitleColor?: string;
    itemBodyColor?: string;
    itemIconBackground?: string;
    panelVariant?: string;
    panelTextOverride?: boolean;
    panelTitleColor?: string;
    panelBodyColor?: string;
    panelBackground?: string;
    label?: string;
    description?: string;
    mediaUrl?: string;
    mediaAlt?: string;
    mediaSize?: string;
    className?: string;
    style?: Record<string, unknown>;
  };
  innerBlocks: BlocksProps[];
};

type IHighlightItemAttrs = {
  label?: string;
  description?: string;
  mediaUrl?: string;
  mediaAlt?: string;
  mediaSize?: string;
};

export default function BlockHighlightGrid({
  attrs,
  innerBlocks,
}: IBlockHighlightGrid) {
  const {
    variant,
    itemTextOverride,
    itemTitleColor,
    itemBodyColor,
    itemIconBackground,
    panelVariant,
    panelTextOverride,
    panelTitleColor,
    panelBodyColor,
    panelBackground,
    label,
    description,
    className,
    style,
  } = attrs || {};

  const elStyle = useMemo(() => ({ ...getBlockStyles({ style }) }), [style]);

  return (
    <HighlightGrid
      variant={variant as "light" | "dark"}
      itemTitleColor={itemTextOverride ? itemTitleColor : undefined}
      itemBodyColor={itemTextOverride ? itemBodyColor : undefined}
      itemIconBackground={itemIconBackground}
      className={className}
      style={elStyle}
      panelElement={
        <HighlightPanel
          variant={panelVariant as "light" | "dark"}
          titleColor={panelTextOverride ? panelTitleColor : undefined}
          bodyColor={panelTextOverride ? panelBodyColor : undefined}
          className={panelBackground}
          icon={mediaIconElement(attrs)}
          label={label}
          description={description?.replace(/\n/g, "<br />")}
        />
      }
    >
      {!!innerBlocks?.length &&
        innerBlocks.map((item: BlocksProps, index: number) => {
          const itemAttrs = (item?.attrs || {}) as IHighlightItemAttrs;

          return (
            <HighlightItem
              key={`highlight-item-${index}`}
              icon={mediaIconElement(itemAttrs)}
              label={itemAttrs.label}
              description={itemAttrs.description?.replace(/\n/g, "<br />")}
            />
          );
        })}
    </HighlightGrid>
  );
}
